import { ReactNode } from 'react';

export const DrawerRowText = ({ children }: { children: ReactNode }) => (
    <span className="font-medium text-secondary">{children}</span>
);
